import React from "react";
import UlLi, { scrollTo, mountCode, initDeepLinkData} from "js/utilities/sdk-doc-utils";
import { Grid, Row, Col, Table, Label, Glyphicon} from "react-bootstrap";
import { Navigation, Link } from "react-router";
import SDKSidebar from "js/utilities/sdk-sidebar"
import UserHandler from "js/utilities/user-handler";
import CodeBlocks from "js/utilities/sdk-doc-code-blocks";
import { ZOOM_ICON } from "js/config.jsx";

import LICENSING_CURL from "resources/code/wildcard-licenses/bash/licensing.bash.tpl";

import LICENSING_RESPONSE_JSON from "resources/code/wildcard-licenses/response/licensing.json.tpl";


import SHORT_EXPIRATION_WILDCARD_LICENSES_PARTNER_SERVER from "resources/img/zoom_short_expiration_wildcard_licenses_partner_server.png";
import SHORT_EXPIRATION_WILDCARD_LICENSES_PARTNER_CUSTOMER_SERVER from "resources/img/zoom_short_expiration_wildcard_licenses_partner_customer_server.png";


export default React.createClass({
  displayName: "zoom-wildcard-licenses",
  scrollToGuide : null,
  scrollingEl : null,
  getInitialState: function() {

    return {
    };
  },

  componentDidMount: function() {
    mountCode(this);
  },

  render: function() {

    if (this.scrollToGuide && this.scrollingEl)
      scrollTo(this.scrollingEl, this.scrollToGuide);
    this.scrollToGuide = null;

    return (
      <div>
        <div className="dash">
          <div className="workspace">
            <div className="workspace__container webservice-documentation">

              <section id="Introduction">
                <div className="title">
                  <Glyphicon glyph="list" />
                  <h2>Short Expiration Wildcard Licenses</h2>
                </div>
                <hr/>
              </section>

              <section>
                <h3>Short Expiration Wildcard Licenses</h3>
                <ul>
                  <li><p>Are for FaceTec Partners who themselves have many customers.</p></li>
                  <li><p>Are Production Keys with have a short (~7 day) expiration.</p></li>
                  <li><p>Allow FaceTec SDKs to work in any app (no specific AppID, BundleID, Domain requirement).</p></li>
                  <li><p>Function exactly like other Production Keys -- same code to initialize.</p></li>
                </ul>
                <br/>
                <br/>
              </section>


              <section>
                <h3>Architectural Diagram - Method 1 - Partner’s SDK Calls Partner’s Server Directly (preferred)</h3>
                <p style={{textAlign:'center'}}><img src={SHORT_EXPIRATION_WILDCARD_LICENSES_PARTNER_SERVER}  width="98%"  style={{maxWidth: '1500px'}} /></p>
                <br/>
                <br/>
              </section>

              <section>
                <h3>Architectural Diagram - Method 2 - Proxying through Partner's Customer's Server</h3>
                <p style={{textAlign:'center'}}><img src={SHORT_EXPIRATION_WILDCARD_LICENSES_PARTNER_CUSTOMER_SERVER}  width="98%"  style={{maxWidth: '1500px'}} /></p>
              </section>

              <section>
                <h3>Calling the API</h3>
                <p>Short Expiration Wildcard SDK Keys must be retrieved via a secure server-to-server call using a special API Key that FaceTec provides.  Developers may not call the FaceTec Key API from clients/devices.</p>

                <p>To call the API and retrieve the Short Expiration Wildcard SDK Keys, simply perform a GET request to the FaceTec Key API endpoint provided by FaceTec, with the API Key provided by FaceTec.  The below code shows a sample curl request.  Please note that the URL and API Key provided below is for demonstration purposes only.  Partners can receive their URL and API Key by contacting us.  Also note that the response from the FaceTec Key API is the exact Key text string that should be used for Device SDK initialization.  The exact string must be used or initialization will not succeed.</p>

                <p><strong>Sample Request:</strong></p>
                <div className="code-container">
                  <CodeBlocks curl={LICENSING_CURL()} />
                </div>

                <p><strong>Sample Response:</strong></p>
                <div className="code-container">
                    <CodeBlocks response={LICENSING_RESPONSE_JSON()} />
                </div>

                <br/>
                <br/>
              </section>

              <SDKSidebar menuType="main" title="FaceTec Server Dedicated & Cloud Architecture"/>

            </div>
          </div>
        </div>
      </div>
    );
  }
});



// WEBPACK FOOTER //
// ./src/js/components/screens/zoom-short-expiration-wildcard-licenses.jsx